import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { ElementRef, Injector, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DeliveryNoteTemplateComponent } from '@components/pdf/delivery-note-template/delivery-note-template.component';
import { DeliveryNotesTableEntry } from '@dto/deliveryNotesTableEntry';
import { TransactionDeliveryNoteDto } from '@dto/transactionDeliveryNoteDto';
import { DeliveryNoteTemplateType } from '@enums/deliveryNoteTemplateType.enum';
import { DeliveryNote } from '@models/deliveryNote';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliveryNotesService } from '@services/entity/delivery-notes.service';
import { UsersService } from '@services/entity/users.service';
import { plainToClass } from 'class-transformer';
import Swal from 'sweetalert2';
import { DeliveryNoteName } from '../../../../dto/deliveryNoteName';
import { Customer } from '../../../../models/customer';
import { FormService } from '../../../../services/form/form.service';
import { ToastService } from '../../../../services/toast/toast.service';
import { DeleteDeliveryNoteDialogContentComponent } from '../../delete-delivery-note-dialog-content/delete-delivery-note-dialog-content';
import { flatMap } from 'rxjs/operators';

@Component({
  selector: 'app-delivery-note-actions-dialog-content',
  templateUrl: './delivery-note-actions-dialog-content.component.html',
  styleUrls: ['./delivery-note-actions-dialog-content.component.scss']
})
export class DeliveryNoteActionsDialogContentComponent extends AbstractDialogContent implements OnInit {
  @ViewChild('inputSendMail') inputElement: ElementRef;
  showEmail: boolean = false;
  isEmailValid: boolean = false;

  public className = 'DeliveryNoteActionsDialogContentComponent';

  public isOperatorView: boolean = false;

  @ViewChild('deliveryNoteActionsComponent') deliveryNoteActionsComponent;
  public entity: DeliveryNote;
  public customerId: number;
  public deliveryNoteId;
  public transactions: TransactionDeliveryNoteDto[];

  public form: UntypedFormGroup;
  public formCreated: boolean;

  public isValid: boolean = true;
  public validationIssue: string;

  constructor(
    public activeModal: NgbActiveModal,
    private deliveryNotesService: DeliveryNotesService,
    private usersService: UsersService,
    private toastService: ToastService,
    private dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getDeliveryNote();
  }

  getDeliveryNote() {
    this.deliveryNotesService.getDeliveryNote(this.deliveryNoteId).subscribe(result => {
      this.entity = plainToClass(DeliveryNote, result);

      if (this.entity.user == null || this.entity.user.addressId == null) {
        this.isValid = false
        this.validationIssue = $localize`:@@DeliveryNoteValidationIssueUserAddress:Bitte beachten Sie, dass der „Empfänger“ des Lieferscheins immer der Benutzer ist, der geladen hat. Wenn im Benutzerprofil Name oder Adresse fehlen, wird der Lieferschein anonym ausgestellt.`
      }

      if (this.isValid) document.getElementById('download_pdf').focus()

      this.createForm();
    })
  }


  downloadCSV() {
    this.toastService.success(`CSV-Datei wird heruntergeladen...`, 2500, true)
    this.deliveryNotesService.getDeliveryNoteAsCSV(this.deliveryNoteId).subscribe((response: any) => {
      try {
        const file = new Blob([response], { type: 'text/csv' });
        const fileUrl = URL.createObjectURL(file);

        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileUrl;
        a.download = this.entity.deliveryNoteNumber;
        a.click();
      } catch (error) {
        console.error(error);
        this.toastService.error(`CSV-Datei konnte nicht heruntergeladen werden.`, 0, true)
      } finally {
        this.toastService.clear()
      }
    }, error => {
      console.error(error);
      this.toastService.error(`CSV-Datei konnte nicht heruntergeladen werden.`, 0, true)
    })

  }

  async getTransactionData() {
    return await this.deliveryNotesService.getTransactionsOfDeliveryNoteAsync(this.deliveryNoteId);
  }

  createForm() {
    this.form = new UntypedFormGroup({
      deliveryNoteNumber: new UntypedFormControl(this.entity.deliveryNoteNumber),
    });

    this.formCreated = true;
  }

  changeDeliveryNoteName() {
    var deliveryNoteName: DeliveryNoteName = {
      deliveryNoteNumber: this.form.get('deliveryNoteNumber').value,
    };

    this.deliveryNotesService.updateDeliveryNoteName(deliveryNoteName, this.entity.id).subscribe(result => {
      this.toastService.success($localize`:@@ChangeDeliveryNoteNameSuccessHeader:Name des Lieferscheins erfolgreich gespeichert.`);
    }, error => {
      this.messageService.setError(error);
    });
  }

  async downloadPdf() {
    this.toastService.loading(`Lieferschein wird heruntergeladen...`)

    this.deliveryNotesService.getDeliveryNotePdf(this.deliveryNoteId).subscribe((response: any) => {
      try {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);

        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileUrl;
        a.download = this.form.get('deliveryNoteNumber').value + '.pdf';
        a.click();

        window.open(fileUrl);
        document.getElementById('x_close').focus()
      } catch (error) {
        console.error(error);
        this.toastService.error(`Lieferschein konnte nicht heruntergeladen werden.`, 0, true)
      } finally {
        this.toastService.clear()
      }
    }, error => {
      console.error(error);
      this.toastService.error(`Lieferschein konnte nicht heruntergeladen werden.`, 0, true)
    })
  }

  openSendPdfEmail() {
    this.showEmail = (!this.showEmail);

    if (this.showEmail) {
      setTimeout(() => {
        const inputElement = document.getElementById('input_sendMail') as HTMLInputElement;
        if (inputElement) {
          inputElement.value = this.entity.user?.email || "";
          this.setIsEmailValid();
        }
      }, 25);
    }
  }
  setIsEmailValid() {
    console.log("setIsEmailValid");

    if (!this.showEmail) {
      this.isEmailValid = false;
      return;
    }


    const inputElement = document.getElementById('input_sendMail') as HTMLInputElement;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    console.log("regex", emailRegex.test(inputElement.value));
    this.isEmailValid = emailRegex.test(inputElement.value);

  }

  async sendPdfEmail() {
    this.toastService.loading(`Lieferschein wird verschickt...`)

    const inputElement = document.getElementById('input_sendMail') as HTMLInputElement;
    const eMailOverwrite = inputElement.value;

    this.deliveryNotesService.sendDeliveryNoteMail(this.deliveryNoteId, eMailOverwrite).subscribe((response: any) => {
      this.toastService.success(`Lieferschein erfolgreich verschickt.`, 0, true)
    }, error => {
      console.error(error);
      this.toastService.error(`Lieferschein konnte nicht verschickt werden.`, 0, true)
    })
    // this.transactions = await this.getTransactionData();
    // var masterUserOfCustomer = await this.usersService.getMasterUserOfCurrentCustomerAsync();

    // const dialogRef = this.dialog.open(DeliveryNoteTemplateComponent, { centered: true, size: 'md', backdrop: 'static'  });
    // dialogRef.componentInstance.type = DeliveryNoteTemplateType.Email;
    // dialogRef.componentInstance.deliveryNote = this.entity;
    // dialogRef.componentInstance.transactions = this.transactions;
    // dialogRef.componentInstance.masterUserOfCustomer = masterUserOfCustomer;

    // dialogRef.result.then((result) => {
    //   var formData = new FormData();
    //   formData.append("file", result.pdf, this.entity.deliveryNoteNumber+ '.pdf');
    //   formData.append("userId", this.entity.userId);
    //   formData.append("deliveryNoteNumber", this.entity.deliveryNoteNumber);
    //   formData.append("deliveryNoteId", this.entity.id.toString());

    //   this.deliveryNotesService.sendEmail(formData).subscribe(result => {
    //     if (result) {
    //       this.openSuccessDialog();
    //     }
    //   });
    // }, (backdrop) => {

    // });
  }

  openDeleteDialog(): void {
    const dialogRef = this.dialog.open(DeleteDeliveryNoteDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.entity = this.entity;

    dialogRef.result.then((result) => {
      if (result.success) {
        this.toastService.success($localize`:@@DeliveryNoteDialogDeleteSuccessHeader:Lieferschein wurde erfolgreich gelöscht.`);
        this.activeModal.close();
      }
      else {
        this.messageService.setError(result.error);
      }
    }, (backdrop) => {

    });
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@DeliveryNoteSendedHeader:Versenden erfolgreich`,
      text: $localize`:@@DeliveryNoteSendedText:Die E-Mail wurde erfolgreich verschickt.`,
      icon: 'success',
      confirmButtonText: $localize`:@@OkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      //this.initializeEntities();
    });
  }
}
